module.exports = __webpack_public_path__ + "img/teams.ac5cdcca.png";